const METRICS_MAP: {[keyName: string]: string} = {
  '1': 'R&D',
  '2': 'Publishing',
  '3': 'Overheads',
  '4': 'Headcount',
  '5': 'Revenue',
  '6': 'ROI',
  '7': 'Profit%',
  '8': 'Total Budget',
  '1-1': 'In-house', // R&D子类
  '1-2': 'Others', // R&D子类
  '4-1': 'In-house', // Headcount子类
  '4-2': 'Others', // Headcount子类
};

const defaultTooltipFormatter = (title: string, params: any) => {
  const { data, name, value } = params;

  if (!data) return null;
  const events = data?.events || [];
  const milestoneList = [];
  let allEvents: any[] = [];
  const isShowCategoryRow = data?.isShowCategoryRow || false;
  for (let i = 0; i < events?.length; i ++) {
    const t = events?.[i];
    t?.name && milestoneList.push(t?.name);
    allEvents = t?.events?.length ? [...allEvents, ...t?.events] : allEvents;
  }

  let tagStr = '', dateRowStr = '', categoryRowStr = '', descriptionRowStr = '';
  for (let i = 0; i < milestoneList?.length; i ++) {
    const t = milestoneList?.[i];
    tagStr += `<span class='info-tag'>${t}</span>`;
  }
  for (let i = 0; i < allEvents?.length; i ++) {
    const t = allEvents?.[i];
    /* // 最多展示15条
    if (allEvents?.length > 15 && i === 15) {
      dateRowStr += `<div class='row-item'>...</div>`;
      categoryRowStr += `<div class='row-item'></div>`;
      descriptionRowStr += `<div class='row-item'></div>`;
      break;
    } else {
      dateRowStr += `<div class='row-item'>${t?.date || '-'}</div>`;
      categoryRowStr += `<div class='row-item'>${METRICS_MAP?.[String(t?.category)] || '-'}</div>`;
      descriptionRowStr += `<div class='row-item'>${t?.description || '-'}</div>`;
    } */
    dateRowStr += `<div class='row-item'>${t?.date || '-'}</div>`;
    categoryRowStr += `<div class='row-item'>${METRICS_MAP?.[String(t?.category)] || '-'}</div>`;
    descriptionRowStr += `<div class='row-item'>${t?.description || '-'}</div>`;
  }

  const htmlStr = `<div>
      <div class='gp-event-echart-tooltip-content'>
        <h3 class='tooltip-top-title'>${title || '-'}</h3>
        <div class='tooltip-top-info' style='max-width: ${isShowCategoryRow ? 830 : 540}px;'>
          <label class='info-label'>Milestone:</label>
          <span class='info-tag-group'>
            ${tagStr || '-'}
          </span>
        </div>
        <div class='tooltip-line'></div>
        <div class='tooltip-body'>
          <div class='body-row-item'>
            <div class='row-title'>Date</div>
            ${dateRowStr || '-'}
          </div>
          ${isShowCategoryRow ? (
            `<div class='body-row-item'>
              <div class='row-title'>Category</div>
              ${categoryRowStr || '-'}
            </div>`
          ) : ''}
          <div class='body-row-item'>
            <div class='row-title'>Description</div>
            ${descriptionRowStr || '-'}
          </div>
        </div>
      </div>
    </div>`;

  return htmlStr;
}

export {
  defaultTooltipFormatter,
}
